module.exports = __webpack_public_path__ + "img/mexico868.d85c922a.jpg";